<template>
  <div v-if="user">
    <h3>
      {{ user.name }}
      <span v-if="isDeleted" class="badge badge-deleted ml-3">gelöscht</span>
      <span v-if="isDeletion" class="badge badge-deletion ml-3"
        >in löschfrist</span
      >
      <span v-if="isDisabled" class="badge badge-disabled ml-3">gesperrt</span>
    </h3>
    <p v-if="isDeleted">Gelöscht am: {{ deleted_at }}</p>
    <p v-if="isDeletion">
      Löschfrist seit: {{ deletion_start_at }}
      <br />
      Bereits in Löschfrist: {{ deletion_time }}
      <br />
      Löschfrist Ende: {{ deletion_end_at }}
    </p>
    <p v-if="isDisabled">
      Gesperrt am: {{ disabled_at }}
      <br />
      Grund: {{ user.disabled_message }}
    </p>
    <div v-if="!isDeleted">
      <v-button @click="editUser()" class="btn-primary">Bearbeiten</v-button>
      <v-button
        @click.native="deleteUser()"
        :working="deleting"
        class="btn-danger"
        >Löschen</v-button
      >
    </div>
    <div class="card">
      <div class="card-header">Stammdaten</div>
      <div class="card-body">
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">ID</label>
          <div class="col-12 col-md-8">
            {{ user.id }}
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Name</label>
          <div class="col-12 col-md-8">
            {{ user.name }}
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Email</label>
          <div class="col-12 col-md-8">
            {{ user.email }}
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Rollen</label>
          <div class="col-12 col-md-8">
            {{ roles }}
          </div>
        </div>
        <div class="form-group row">
          <label class="col-sm-4 col-form-label">Erstellt am</label>
          <div class="col-12 col-md-8">
            {{ user.created_at }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store";
import {
  getDateTimeHtml,
  getDateTimeHtmlAddMinutes,
  getTimeDifference
} from "@/js/date";

export default {
  beforeRouteEnter(to, from, next) {
    store
      .dispatch("user/read", {
        filter: [
          {
            name: "where",
            attributes: {
              id: [Number(to.params.id)]
            }
          },
          {
            name: "with",
            value: ["roles"]
          }
        ],
        appends: ["delete_url"]
      })
      .then(() => {
        next();
      });
  },
  data() {
    return {
      deleting: false
    };
  },
  computed: {
    deleted_at() {
      return getDateTimeHtml(this.user.deleted_at);
    },
    disabled_at() {
      return getDateTimeHtml(this.user.disabled_at);
    },
    deletion_start_at() {
      return getDateTimeHtml(this.user.deletion_at);
    },
    deletion_time() {
      return getTimeDifference(this.user.deletion_at);
    },
    deletion_end_at() {
      return getDateTimeHtmlAddMinutes(
        this.user.deletion_at,
        Laravel.settings.deletion_time
      );
    },
    id() {
      return Number(this.$route.params.id);
    },
    user() {
      return this.$store.getters["user/find"](this.id);
    },
    isDeleted() {
      return this.user.deleted_at;
    },
    isDisabled() {
      return this.user.disabled_at;
    },
    isDeletion() {
      return this.user.deletion_at;
    },
    roles() {
      return this.user.roles.map(role => role.name).join(", ");
    }
  },
  methods: {
    deleteUser() {
      if (this.deleting) {
        return;
      }
      if (!confirm("Sicher?")) {
        return;
      }
      this.deleting = true;
      this.$store
        .dispatch("user/delete", { url: this.user.delete_url })
        .then(() =>
          this.$notify({
            title: `${this.user.name} wurde gelöscht`,
            type: "success"
          })
        )
        .then(() => this.$router.push("/systemuser/list"))
        .finally(() => (this.deleting = false));
    },
    editUser() {
      this.$router.push(`/systemuser/${this.user.id}`);
    }
  }
};
</script>

<style></style>
